/** Why someone dismissed a match; asked on dismiss, never required. */
export const DISMISS_REASONS = ["not_relevant", "already_know_someone", "wrong_person", "not_now", "other"];
export const DISMISS_REASON_LABELS = {
    not_relevant: "Not relevant",
    already_know_someone: "Already know someone",
    wrong_person: "Wrong person",
    not_now: "Not now",
    other: "Other",
};
export const FEEDBACK_PLATFORMS = ["web", "mac", "ios"];
export const FEEDBACK_PLATFORM_LABELS = { web: "Web", mac: "Mac", ios: "iPhone" };
export const FEEDBACK_MESSAGE_MAX = 5000;
export const FEEDBACK_CONTEXT_MAX = 200;
export const MATCH_STAGES = ["found", "shared", "accepted", "introduced", "done", "dismissed", "expired"];
//# sourceMappingURL=admin.js.map